import { Pipe, PipeTransform } from '@angular/core';
import moment from 'moment';
import { toRelative } from '../../utils/relative-time';

@Pipe({
    name: 'relativeDateTime',
    standalone: false
})
export class RelativeDateTimePipe implements PipeTransform {

  transform(value: moment.Moment | null | string, ...args: any[]): any {
    if (!value) {
      return;
    }

    return toRelative(value);
  }

}
